<template>
    <div class="row pt-3">
        <HistoryComponent />
    </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import HistoryComponent from "@/components/history/index";

export default {
    mixins: [languageMixins ],
    components: {
        HistoryComponent
    },
}
</script>
